import * as yup from 'yup'

const timeRangeSchema = yup.object({
	start: yup.string(),
	end: yup.string(),
})

const dayScheduleSchema = yup.object({
	isActive: yup.boolean(),
	dateRanges: yup.array().of(timeRangeSchema),
})

export const getOpeningHoursSchema = () =>
	yup.object({
		isAm: yup.boolean(),
		monday: dayScheduleSchema.nullable(),
		tuesday: dayScheduleSchema.nullable(),
		wednesday: dayScheduleSchema.nullable(),
		thursday: dayScheduleSchema.nullable(),
		friday: dayScheduleSchema.nullable(),
		saturday: dayScheduleSchema.nullable(),
		sunday: dayScheduleSchema.nullable(),
	})
